import { useSubscription } from '@apollo/client';
import { UserEventsDocument } from '~/graphql/subscriptions/userEvents';
import {
  handleMatterActivityReceived,
  handleMessageReceived,
} from '~/hooks/userEventHandlers';

export const useUserEvents = () => {
  useSubscription(UserEventsDocument, {
    onData: ({ data, client }) => {
      const event = data.data?.userEvents;
      if (!event) {
        return;
      }

      switch (event.__typename) {
        case 'MessageReceived': {
          handleMessageReceived(event, client);
          break;
        }
        case 'MatterActivityReceived': {
          handleMatterActivityReceived(event, client);
          break;
        }
      }
    },
  });
};
